// extracted by mini-css-extract-plugin
module.exports = {"perfil":"Feed_perfil__1jqWi","outside":"Feed_outside__2EtGA"};